"use strict";

/**
 * Checks if the value is a number.
 * @param {*} value
 * @returns {boolean}
 */
function isNumber(value) {
  // don't do !isNaN(value), it fails for booleans
  return typeof value === "number";
}

module.exports = {
  isNumber
};
